/**
 * Canonical patient (public) website origin for partner landing URLs when env is unset.
 * Production commonly serves both https://inoqare.com and https://www.inoqare.com; preview links use www.
 */
export const DEFAULT_PATIENT_WEB_ORIGIN = "https://www.inoqare.com";

export const FALLBACK_TIMEZONES = [
  "UTC",
  "Europe/Paris",
  "Europe/London",
  "Europe/Brussels",
  "America/New_York",
  "America/Los_Angeles",
  "America/Mexico_City",
  "Asia/Tokyo",
  "Asia/Singapore",
  "Asia/Dubai",
  "Australia/Sydney",
  "Africa/Casablanca",
];

export const LANGUAGE_SELECT_OPTIONS = [
  { value: "en", label: "English (en)" },
  { value: "fr", label: "French (fr)" },
  { value: "de", label: "German (de)" },
  { value: "es", label: "Spanish (es)" },
  { value: "it", label: "Italian (it)" },
  { value: "pt", label: "Portuguese (pt)" },
  { value: "nl", label: "Dutch (nl)" },
  { value: "ar", label: "Arabic (ar)" },
  { value: "ro", label: "Romanian (ro)" },
  { value: "pl", label: "Polish (pl)" },
];
